import React from 'react';
import { Box, Button, ButtonBase } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { RADIUS } from './lib/brand';

const BASE = '/dashboard/bot-ops';
export const NAV: { label: string; to: string; match: (p: string) => boolean }[] = [
  { label: 'Operations', to: BASE, match: (p) => p === BASE || p === `${BASE}/` || p.startsWith(`${BASE}/bots/`) },
  { label: 'Activity', to: `${BASE}/activity`, match: (p) => p.startsWith(`${BASE}/activity`) },
  { label: 'Scorecard', to: `${BASE}/scorecard`, match: (p) => p.startsWith(`${BASE}/scorecard`) },
  { label: 'Audit trail', to: `${BASE}/audit`, match: (p) => p.startsWith(`${BASE}/audit`) },
];

/** The strip above every Grokbot page: where you are, and the global tools (search, views, theme). */
export function BotOpsToolbar({ tools }: { tools?: React.ReactNode }) {
  const { pathname } = useLocation();
  return (
    <Box component="nav" aria-label="Grokbot" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap', px: { xs: 1.5, md: 3 }, pt: 1.5, maxWidth: 1480, mx: 'auto' }}>
      {NAV.map((n) => {
        const on = n.match(pathname);
        return (
          <ButtonBase
            key={n.to}
            component={RouterLink}
            to={n.to}
            aria-current={on ? 'page' : undefined}
            sx={{ fontSize: 13, fontWeight: on ? 800 : 600, px: 1.4, py: 0.6, borderRadius: RADIUS.pill, color: on ? 'primary.contrastText' : 'text.primary', bgcolor: on ? 'primary.main' : 'transparent', '&:hover': { bgcolor: on ? 'primary.main' : 'action.hover' } }}
          >
            {n.label}
          </ButtonBase>
        );
      })}
      <Box sx={{ flex: 1 }} />
      {tools}
    </Box>
  );
}

export const ToolButton = (props: React.ComponentProps<typeof Button>) => <Button size="small" variant="outlined" {...props} sx={{ textTransform: 'none', borderRadius: RADIUS.pill, ...(props.sx || {}) }} />;
